// extracted by mini-css-extract-plugin
export default {"durationOrQuantityTextbox":"DosageDurationOrQuantityEditForm_durationOrQuantityTextbox__ESgNn","hyperlinkContainer":"DosageDurationOrQuantityEditForm_hyperlinkContainer__XfKH+"};